"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = exports.StyledButton = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importDefault(require("react"));
var styled_system_1 = require("styled-system");
var Spinner_1 = require("./Spinner");
var Text_1 = require("./Text");
var theme_1 = require("./theme");
var colors_1 = require("./utils/colors");
var getLoadingStyle = function (variant, size, secondaryThemeColor) {
    var style = {};
    if (variant === "primary") {
        style.primaryColor = secondaryThemeColor;
    }
    else {
        style.primaryColor = "#141415";
    }
    if (size === "large") {
        style.size = 14;
    }
    else {
        style.size = 12;
    }
    return style;
};
/**
 * Button UI component
 * @param {string=} [variant=primary] - Can be either primary or secondary. Primary buttons will use the primary theme color.
 * @param {string=} [size=medium] - Can be xsmall, small, medium, or large
 * @param {boolean=} [loading=false] - Shows a loading spinner
 */
var Button = function (_a) {
    var children = _a.children, _b = _a.variant, variant = _b === void 0 ? "primary" : _b, _c = _a.size, size = _c === void 0 ? "medium" : _c, loading = _a.loading, props = __rest(_a, ["children", "variant", "size", "loading"]);
    var secondaryThemeColor = (0, colors_1.useSecondaryThemeColor)();
    var textStyle = ["xsmall", "small"].includes(size)
        ? "uiSmall600"
        : "uiLarge600";
    var loadingStyles = getLoadingStyle(variant, size, secondaryThemeColor);
    return (react_1.default.createElement(exports.StyledButton, __assign({ variant: variant, size: size, loading: loading, secondaryThemeColor: secondaryThemeColor }, props, { disabled: loading || props.disabled }),
        loading && react_1.default.createElement(Spinner_1.Spinner, __assign({}, loadingStyles)),
        react_1.default.createElement(VisibilityToggle, { visible: !loading },
            react_1.default.createElement(Text_1.Text, { variant: textStyle }, children))));
};
exports.Button = Button;
exports.StyledButton = styled_1.default.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  border: 0;\n  margin: 0;\n  cursor: pointer;\n  display: inline-block;\n  text-decoration: none;\n  white-space: nowrap;\n  outline: none;\n  border-radius: ", ";\n\n  &:focus-visible {\n    &:not(:disabled) {\n      box-shadow: inset 0px 0px 0px 2px ", ";\n    }\n  }\n\n  &:disabled {\n    ", "\n  }\n\n  &:hover:not(:disabled) {\n    &::after {\n      content: \"\";\n      position: absolute;\n      top: 0;\n      bottom: 0;\n      left: 0;\n      right: 0;\n      background-color: ", ";\n      mix-blend-mode: overlay;\n      opacity: 0.22;\n      border-radius: ", ";\n    }\n  }\n\n  ", ";\n\n  ", ";\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  position: relative;\n  border: 0;\n  margin: 0;\n  cursor: pointer;\n  display: inline-block;\n  text-decoration: none;\n  white-space: nowrap;\n  outline: none;\n  border-radius: ", ";\n\n  &:focus-visible {\n    &:not(:disabled) {\n      box-shadow: inset 0px 0px 0px 2px ", ";\n    }\n  }\n\n  &:disabled {\n    ", "\n  }\n\n  &:hover:not(:disabled) {\n    &::after {\n      content: \"\";\n      position: absolute;\n      top: 0;\n      bottom: 0;\n      left: 0;\n      right: 0;\n      background-color: ", ";\n      mix-blend-mode: overlay;\n      opacity: 0.22;\n      border-radius: ", ";\n    }\n  }\n\n  ", ";\n\n  ", ";\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), function (_a) {
    var size = _a.size;
    return (size === "large" ? "126px" : "8px");
}, theme_1.theme.colors.gray900, function (_a) {
    var loading = _a.loading;
    return loading
        ? "cursor: wait;"
        : "\n            background: ".concat(theme_1.theme.colors.gray200, ";\n            color: ").concat(theme_1.theme.colors.gray400, ";\n            cursor: default;\n            box-shadow: none;\n          ");
}, theme_1.theme.colors.black, function (_a) {
    var size = _a.size;
    return (size === "large" ? "126px" : "8px");
}, function (_a) {
    var secondaryThemeColor = _a.secondaryThemeColor, size = _a.size;
    return (0, styled_system_1.variant)({
        prop: "variant",
        variants: {
            primary: {
                bg: "primary",
                color: secondaryThemeColor,
            },
            secondary: {
                bg: "white",
                color: "gray800",
                boxShadow: "inset 0px 0px 0px 1px ".concat(theme_1.theme.colors.gray400),
                "&:hover": {
                    bg: "gray200",
                },
                "&:not(:disabled)::after": {
                    content: '""',
                    inset: 0,
                    position: "absolute",
                    boxShadow: "0px 0.5px 1px #0000001F",
                    borderRadius: size === "large" ? "126px" : "8px",
                },
            },
        },
    });
}, (0, styled_system_1.variant)({
    prop: "size",
    variants: {
        xsmall: {
            padding: "8px",
        },
        small: {
            padding: "12px 14px",
        },
        medium: {
            padding: "14px",
        },
        large: {
            padding: "16px 40px",
        },
    },
}), styled_system_1.width, styled_system_1.maxWidth, styled_system_1.maxHeight, styled_system_1.display, styled_system_1.space, styled_system_1.color);
var VisibilityToggle = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  visibility: ", ";\n"], ["\n  visibility: ", ";\n"])), function (_a) {
    var visible = _a.visible;
    return (visible ? "inherit" : "hidden");
});
var templateObject_1, templateObject_2;
